<template>
  <v-container class="kahon p-0 m-0" fluid>
    <v-row class="text-center" align="center" justify="center">
      <v-col cols="12" lg="4" md="5">
        <v-img
          class="mx-auto"
          :src="require('../assets/How it Works - We Return1.png')"
          width="400"
          contain
        />
      </v-col>
      <v-col cols="12" lg="4" md="5">
        <h1 class="display-2 text-start white--text mb-3 font-weight-black">
          Sign Up
        </h1>
        <p class="text-start white--text">
          Since wire-frame renderings are relatively simple and fast to
          calculate.
        </p>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            outlined
            single-line
            background-color="#fff"
            color="#47abe1"
            required
          ></v-text-field>

          <v-text-field
            v-model="mobileNumber"
            :rules="mobileRules"
            label="Mobile Number"
            outlined
            single-line
            background-color="#fff"
            color="#47abe1"
            mask="###-#######"
            required
          ></v-text-field>

          <v-text-field
            v-model="firstname"
            :rules="nameRules"
            label="First Name"
            outlined
            single-line
            background-color="white"
            color="#47abe1"
            required
          ></v-text-field>

          <v-text-field
            v-model="lastname"
            :rules="nameRules"
            label="Last Name"
            outlined
            single-line
            background-color="white"
            color="#47abe1"
            required
          ></v-text-field>

          <div class="my-2 text-left">
            <v-btn large color="primary" class="ml-auto" @click="validate()"
              >Submit</v-btn
            >
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mask } from "vue-the-mask";
import axios from 'axios';
export default {
  name: "Landing6SignUp",
  directives: { mask },
  data: () => ({
    valid: true,
    firstname: "",
    lastname: "",
    nameRules: [
      (v) => !!v || "Name is required",
      (v) => (v && v.length <= 25) || "Name must be less than 25 characters",
    ],
    mobileRules: [
      (v) => !!v || "Mobile Number is required",
      (v) =>
        (v && v.length <= 25) ||
        "Mobile Number must be only less than 13 characters",
    ],
    email: "",
    mobileNumber: "",
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false,
    show1: false,
    rules: {
      emailMatch: () => "The email and password you entered don't match",
    },
  }),
  methods: {
    validate() {
      if (!this.$refs.form.validate()) {
        this.$refs.form.validate();
      } else {
        this.$refs.form.$el.submit();
        try {
          axios
            .post("https://sandbox-kahon.herokuapp.com/api/v1/signup", {
              email: this.email,
              mobileNumber: this.mobileNumber,
              firstname: this.firstname,
              lastname: this.lastname,
            });
            // .then((response) => {
            //   if (response.status == 201) {
            //     this.savingSuccessful = true;
            //     this.message = "Transaction has been successfully saved!";
            //     this.color = "success";
            //     this.isFormSent = true;
            //     this.overlay = false;
            //   }
            // })
            // .catch(() => {
            //   this.savingNotSuccessful = true;
            //   this.message =
            //     "There was an error to the request. But your request will be sent once problems are resolved.\nThings to fix this:\n1. Check for internet connection. Make sure device is connected on the internet.\n2. Refresh the website";
            //   this.color = "error";
            //   this.isFormSent = true;
            //   this.overlay = false;
            // });
        } catch (error) {
          this.savingNotSuccessful = true;
          this.message =
            "There was an error to the request. But your request will be send once problems are resolved.";
          this.color = "error";
          this.isFormSent = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.display-2 {
  font-family: "Work Sans", sans-serif !important;
  font-display: swap;
}
</style>
